import { Input, Stack } from '@chakra-ui/react'
import { UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form'

import { CustomForm } from 'components/tools/CustomForm/types'
import { FormItem } from 'components'
import ScoreClassificationIntervals from './components/ScoreClassificationIntervals'

type Props = {
  register: UseFormRegister<CustomForm>
  setValue: UseFormSetValue<CustomForm>
  watch: UseFormWatch<CustomForm>
}

export default function ScoreClassifications({ register, setValue, watch }: Props) {
  return (
    <Stack p={2}>
      <FormItem label="Nome da classificação" mb={2}>
        <Input {...register('name')} />
      </FormItem>

      <ScoreClassificationIntervals watch={watch} setValue={setValue} />
    </Stack>
  )
}
